module.exports = __webpack_public_path__ + "images/103_2048.jpg";